/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import FacilityOverview from './FacilityOverview';
import redFlag from '../../../assets/images/red-flag-icon.svg';

import './FacilityInfo.scss';

/* eslint-disable react/function-component-definition */
const FacilityInfoPage = ({ setShowLoadingSpinner, activeFacility }) => {
	return (
		<div className="facility-info-page">
			<div className="facility-info-warning-box">
				<img alt="flag" src={redFlag} />
				<p>
					<b>Attention</b>: This information will display in the ShiftMed App for the Healthcare Professional. Please
					fill out the required information to ensure the workers want to work at your facility and are set up for
					success for the shift upon being claimed.
				</p>
			</div>
			<FacilityOverview setShowLoadingSpinner={setShowLoadingSpinner} activeFacility={activeFacility} />
		</div>
	);
};

export default FacilityInfoPage;
